import Card from './Card'

type NotFoundProps = {
  title?: string
  subtitle?: string
}

export const NotFoundComponent = ({ title, subtitle }: NotFoundProps) => (
  <div>
    <div className="space-y-2">
      <h2 className="text-lg font-bold">{title || 'Não encontrado'}</h2>
      <p className="text-sm">
        {subtitle || 'Recurso não encontrado no servidor'}
      </p>
    </div>
  </div>
)

export const NotFoundWithCard = (props: NotFoundProps) => {
  return (
    <Card className="font-medium text-slate-700 p-6 flex-col mx-auto">
      {/* <Card className="font-medium text-slate-700 max-w-6xl p-8 flex gap-4 flex-col text-center mx-auto"> */}
      <NotFoundComponent {...props} />
    </Card>
  )
}
